<template>
<div>
    <div class="funds-tab">
        <v-tabs v-model="tab" fixed-tabs centered dark icons-and-text height="auto" :hide-slider="true">
            <!-- <v-tabs-slider></v-tabs-slider> -->
            <v-tab href="#deposit" dark>{{$t(`label.deposit`)}}</v-tab>
            <v-tab href="#withdrawal" dark>{{$t(`label.withdrawal`)}}</v-tab>
        </v-tabs>
    </div>
    <v-tabs-items v-model="tab" :click="changeTab()" touchless>
        <v-tab-item :value="'deposit'">
            <deposit></deposit>
        </v-tab-item>
        <v-tab-item :value="'withdrawal'">
            <withdrawal ref="withdrawal"></withdrawal>
        </v-tab-item>
    </v-tabs-items>
    <instant-popup-dialog
        :dialog-show="instantDialogShow"
        :max-width="438"
        :closeAction="this.closeInstantPopup"
        :array-info="popupAnnouncement"
    ></instant-popup-dialog>
</div>
</template>

<script>
import Deposit from '@/views/bank/deposit.vue'
import Withdrawal from '@/views/bank/withdrawal.vue'
import InstantPopupDialog from '@/components/InstantPopupDialog.vue'
import { uiHelper } from '@/util'

export default {
    name: 'funds',
    components: {
        Deposit,
        Withdrawal,
        InstantPopupDialog
    },
    data() {
        return {
            tab: this.$route.params.tab,
            currentLanguage: uiHelper.getLanguage(),
            instantDialogShow: false,
            // A global page dialog is currently showing (e.g. the withdrawal
            // "transfer to main wallet" confirmation) - our popup must wait.
            pageDialogOpen: false,
            // The withdrawal confirmation has been dismissed this session, so
            // the withdrawal popup is now allowed to show.
            withdrawalConfirmDismissed: false
        }
    },
    computed: {
        // Payment-type popups scoped to the active bank tab via sub_announcement:
        // show when the announcement targets this tab's subtype (deposit/withdrawal),
        // or has no subtype at all (generic payment popup shows on both tabs).
        popupAnnouncement() {
            let activeTab = this.tab || 'deposit'
            let p = []
            let k = this.$store.state.announcement.popupAnnouncement.filter(announcement => {
                if (announcement.type !== 'payment') return false
                let subs = Array.isArray(announcement.subAnnouncement)
                    ? announcement.subAnnouncement.map(s => String(s).toLowerCase())
                    : []
                return subs.length === 0 || subs.includes(activeTab)
            })
            k.forEach(announcement => {
                p.push({
                    id: announcement.id,
                    date: announcement.announcementDate,
                    title:
                        announcement.titleLocale.find(x => x.language == this.currentLanguage) != null
                            ? announcement.titleLocale.find(x => x.language == this.currentLanguage).title
                            : announcement.titleLocale.find(x => x.language == 'en') != null
                            ? announcement.titleLocale.find(x => x.language == 'en').title
                            : announcement.titleLocale[0].title,
                    message:
                        announcement.messageLocale.find(x => x.language == this.currentLanguage) != null
                            ? announcement.messageLocale.find(x => x.language == this.currentLanguage).message
                            : announcement.messageLocale.find(x => x.language == 'en') != null
                            ? announcement.messageLocale.find(x => x.language == 'en').message
                            : announcement.messageLocale[0].message,
                    alwaysShow: announcement.alwaysShow
                })
            })
            // Drop "show once" announcements the user already dismissed on this
            // tab; always_show ones are never filtered, so an urgent notice can
            // force the popup open without dragging dismissed items back into the
            // carousel.
            let dismissed = this.dismissedIds()
            return p.filter(a => a.alwaysShow || !dismissed.includes(String(a.id)))
        }
    },
    watch: {
        // Open/close the popup as the active tab (and thus the scoped list)
        // changes. Kept in a watcher rather than the computed to avoid side
        // effects during render.
        popupAnnouncement: {
            immediate: true,
            handler() {
                this.tryOpenPopup()
            }
        },
        tab(value, oldValue) {
            // Vuetify's mandatory tab selection writes 'deposit' over the initial
            // undefined during the first render. The deposit form's own created()
            // hook already covers that pass, so only report genuine switches.
            if (oldValue === undefined) {
                return
            }
            // Both tabs stay mounted once rendered, so created() does not run
            // again. Report every switch so the deposit form can re-run its
            // phone-verification gate and know when it is no longer on screen.
            this.$eventHub.$emit('funds-tab-changed', value)
        }
    },
    created() {
        this.tab = this.$route.params.tab;
        this.$eventHub.$on('change-funds-tab', (tab) => {
            this.tab = tab
        })
        this.$eventHub.$on('open-page-dialog', this.onPageDialogOpen)
        this.$eventHub.$on('close-page-dialog', this.onPageDialogClose)
    },
    beforeDestroy() {
        this.$eventHub.$off('open-page-dialog', this.onPageDialogOpen)
        this.$eventHub.$off('close-page-dialog', this.onPageDialogClose)
    },
    methods: {
        changeTab() {
            if(this.tab == 'withdrawal') {
                console.log('withdrawal')
                // this.$refs.withdrawal.openConfirmationDialog()
                this.$eventHub.$emit('open-confirm-dialog')
            }
        },
        // Decide whether the payment popup may show right now. It is held back
        // while a global page dialog is open, and - on the withdrawal tab -
        // until the "transfer to main wallet" confirmation has been dismissed.
        tryOpenPopup() {
            if (this.popupAnnouncement.length === 0) {
                this.instantDialogShow = false
                return
            }
            if (this.pageDialogOpen) {
                this.instantDialogShow = false
                return
            }
            if ((this.tab || 'deposit') === 'withdrawal' && !this.withdrawalConfirmDismissed) {
                this.instantDialogShow = false
                return
            }
            this.openInstantPopup()
        },
        onPageDialogOpen() {
            // A page dialog (withdrawal confirmation / turnover notice / etc.)
            // is showing - hide our popup so the two never stack.
            this.pageDialogOpen = true
            this.instantDialogShow = false
        },
        onPageDialogClose() {
            this.pageDialogOpen = false
            // A confirmation dismissed while on the withdrawal tab is the
            // "transfer to main wallet" prompt - unlock the withdrawal popup.
            if ((this.tab || 'deposit') === 'withdrawal') {
                this.withdrawalConfirmDismissed = true
            }
            this.tryOpenPopup()
        },
        // Per-tab dismiss cookie so dismissing the deposit popup does not
        // suppress the withdrawal popup (and vice versa). 0.5 day = 12h TTL.
        openInstantPopup() {
            // Avoid stacking with EV-2872's static "Important Notice"
            // (showFundNotice in deposit.vue/withdrawal.vue), which auto-opens on
            // mobile (breakpoint < md) until its own 1-day cookie is set. Defer our
            // payment popup while that notice will show, so only one dialog appears.
            let fundNoticeWillShow =
                !this.$vuetify.breakpoint.mdAndUp && uiHelper.getCookie('showFundNotice') == null
            if (fundNoticeWillShow) {
                return
            }
            // popupAnnouncement is already filtered to drop dismissed "show once"
            // items (always_show ones are kept), so open whenever anything remains.
            // always_show therefore reappears every visit; a fully-dismissed set
            // leaves the list empty and the popup stays closed.
            if (this.popupAnnouncement.length > 0) {
                this.instantDialogShow = true
            }
        },
        closeInstantPopup() {
            // Record which "show once" announcements were dismissed (per tab) so
            // they stay hidden even when an always_show announcement later forces
            // the popup open. always_show items are never recorded. 0.5 day = 12h.
            let tab = this.tab || 'deposit'
            let dismissed = this.dismissedIds()
            this.popupAnnouncement.forEach(a => {
                if (!a.alwaysShow && !dismissed.includes(String(a.id))) {
                    dismissed.push(String(a.id))
                }
            })
            uiHelper.setCookie(`popup_dismissed_${tab}`, dismissed.join(','), 0.5)
            this.instantDialogShow = false
        },
        dismissedIds() {
            let raw = uiHelper.getCookie(`popup_dismissed_${this.tab || 'deposit'}`)
            return raw ? String(raw).split(',').filter(Boolean) : []
        }
    }
}
</script>

<style lang="scss">
.funds-tab {
    padding: 12px;
    background: var(--v-primary-base);

    .v-tabs-bar {
        background: var(--v-primary-base) !important;
    }

    .v-tab {
        background: #514bbe;
        color: #ffffff !important;
        text-transform: capitalize;
        padding: 4px;
    }

    .v-tab--active {
        background: #f56908;

        &::before {
            content: '';
            padding: 8px;
            background: #f56908;
        }
    }
}

.funds-container {
    display: flex;
    max-width: 1240px;
    margin: auto;

    .side-funds-wrapper {
      margin-top: 20px;
      width: 30%;
    }

    .funds-wrapper {
        max-width: 70%;
        margin: auto;
        background: var(--v-background-lighten2);

        .funds-input {
            padding-right: 12px;
            font-size: 14px;

            .v-input__slot {
                color: transparent;

            }
        }

        .funds-divider {
            width: 100%;
            height: 1px;
            background-color: var(--v-divider-base);
            margin: 2px 0px;
        }

        .gateway-button {
            border: 1px solid var(--v-base-base);
            //background: rgba(255, 255, 255, 0.1);
            background-color: var(--v-background-base);
            padding: 8px;
            min-width: 100px;
            width: auto;

            .v-btn__content {
                display: flex;
                flex-direction: column;

                img {
                    width: 24px;
                    height: 24px;
                }

                label {
                    text-transform: capitalize;
                }
            }
        }

        .active-gateway-button {
            &.v-btn--active {
                border: 2px solid var(--v-primary-base);
            }
        }

        .section-container {
            position: relative;
            margin-top: 12px;
            padding: 12px;
            background: var(--v-background-lighten1);

            .funds-title-wrapper {
                position: relative;
                padding-left: 12px;
                margin-bottom: 8px;

                .funds-title::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 4px;
                    height: 100%;
                    background-color: var(--v-primary-base);
                }
            }

            .button-container {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 12px;
                margin-top: 8px;
            }
        }

        .funds-button {
            background: var(--v-primary-base);
            border-radius: 4px;
            width: 100%;
        }

        .v-stepper__content {
            padding: unset;
        }
    }
}
</style>
